/* Concha Labs — shared site behavior */
(function () {
  "use strict";

  // Mobile nav toggle
  var toggle = document.querySelector(".nav-toggle");
  var nav = document.querySelector(".nav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", nav.classList.contains("open") ? "true" : "false");
    });
  }

  // FAQ accordions
  document.querySelectorAll(".faq-item button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = btn.closest(".faq-item");
      var panel = item.querySelector(".faq-a");
      var isOpen = item.classList.contains("open");

      if (isOpen) {
        panel.style.maxHeight = "0px";
        item.classList.remove("open");
        btn.setAttribute("aria-expanded", "false");
      } else {
        item.classList.add("open");
        panel.style.maxHeight = panel.scrollHeight + "px";
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });

  // Color swatch selection (product page) — also swaps the main photo
  var mainImg = document.querySelector("[data-gallery-main]");
  document.querySelectorAll(".swatches").forEach(function (group) {
    var label = document.querySelector("[data-swatch-label]");
    group.querySelectorAll(".swatch").forEach(function (sw) {
      sw.addEventListener("click", function () {
        group.querySelectorAll(".swatch").forEach(function (s) { s.classList.remove("active"); });
        sw.classList.add("active");
        if (label) label.textContent = sw.getAttribute("data-name") || "";
        var img = sw.getAttribute("data-img");
        if (mainImg && img) { mainImg.src = img; mainImg.alt = "Concha Sol hearing aids in " + (sw.getAttribute("data-name") || "").toLowerCase(); }
      });
    });
  });

  // Simple gallery swap (product page)
  document.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
    t.addEventListener("click", function () {
      if (mainImg) { mainImg.src = t.getAttribute("data-full") || t.getAttribute("src"); mainImg.alt = t.getAttribute("alt") || ""; }
      document.querySelectorAll("[data-gallery-thumb]").forEach(function (o) { o.classList.remove("active"); });
      t.classList.add("active");
    });
  });

  // NCOA score gauge: fill + count up when scrolled into view
  document.querySelectorAll(".score").forEach(function (sc) {
    var val = sc.querySelector(".score__val");
    var target = parseFloat(sc.getAttribute("data-score") || "0");
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function run() {
      sc.classList.add("is-on");
      if (!val) return;
      if (reduce) { val.textContent = target.toFixed(1); return; }
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / 1500);
        var e = 1 - Math.pow(1 - p, 3);
        val.textContent = (target * e).toFixed(1);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { run(); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(sc);
    } else { run(); }
  });

  // Sticky mobile CTA: hide on the booking page itself
  var sticky = document.querySelector(".sticky-cta");
  if (sticky && /(?:book\.html|\/pages\/book)\/?$/.test(window.location.pathname)) sticky.style.display = "none";

  // Footer year
  var yr = document.querySelector("[data-year]");
  if (yr) yr.textContent = new Date().getFullYear();
})();
